<template>
    <div class="shareExperience">
        <!-- 点击我想要这份礼服跳转share-experience -->
        <div class="step_title">
            <p><span>Step 2 of 4:</span> Tell Us Your Experience About It</p>
             <el-progress :text-inside="true" :stroke-width="24" :percentage="50" status="success"></el-progress>
        </div>
        <div class="post-content">
            <div class="post-content-left">
                <div class="fusion-title">{{title}}</div>
                <img :src="image" alt="" style="width: 200px;">
            </div>
            <el-card class="box-card">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-width="auto"  label-position="top">
                    <el-form-item label="How do you like our product?" prop="likeability">
                            <el-radio-group v-model="ruleForm.likeability">
                                <el-radio label="I Hate It"></el-radio>
                                <el-radio label="I Don't Like It"></el-radio>
                                <el-radio label="Just So So"></el-radio>
                                <el-radio label="I Like It"></el-radio>
                                <el-radio label="I Love It"></el-radio>
                            </el-radio-group>
                    </el-form-item>
                    <el-form-item label="How like will you share our product with your friend/family?" prop="shareLevel">
                        <el-radio-group v-model="ruleForm.shareLevel">
                            <el-radio label="1"></el-radio>
                            <el-radio label="2"></el-radio>
                            <el-radio label="3"></el-radio>
                            <el-radio label="4"></el-radio>
                            <el-radio label="5"></el-radio>
                            <el-radio label="6"></el-radio>
                            <el-radio label="7"></el-radio>
                            <el-radio label="8"></el-radio>
                            <el-radio label="9"></el-radio>
                            <el-radio label="10"></el-radio>
                        </el-radio-group>
                        <p style="margin-top:-10px;">1 = Not at all likely - 10 = Exteremely likely</p>
                    </el-form-item>
                    <el-form-item label="Let's us know your comment about the product.*" prop="comment">
                        <p style="margin-top:-25px;">Please enter at least 60 characters.</p>
                         <el-input type="textarea" v-model="ruleForm.comment"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="submitForm('ruleForm')">Next Step</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>
<script>
import {freeGiftOrderThree} from '../../../api/freeGift'
export default {
    data() {
        // 登录界面邮箱验证
        var comment = (rule, value, callback) => {
            // 邮箱正则
          // eslint-disable-next-line no-control-regex
            var bytesLen = value.replace(/[^\x00-\xff]/g, 'xx').length;
            if (bytesLen < 60){
               callback(new Error('Please enter at least 60 characters.'))
            }else{
                callback()
            }
        }
        return {
            title:'',
            image:'',
            ruleForm:{
                amazonOrderId:'',
                likeability:'',
                shareLevel:'',
                comment:''
            },
            rules:{
                likeability: [
                    { required: true, message: '请选择是否喜欢我们产品', trigger: 'change' }
                ],
                shareLevel: [
                    { required: true, message: '请选择是否愿意与家人朋友分享我们的产品', trigger: 'change' }
                ],
                comment: [
                    // { required: true, message: '请填写对我们产品的意见', trigger: 'blur' }
                     {required: true, validator: comment, trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    sessionStorage.share2likeability = this.ruleForm.likeability;
                    sessionStorage.share2share_level = this.ruleForm.shareLevel;
                    sessionStorage.share2comment = this.ruleForm.comment;
                    if(this.ruleForm.likeability == "I Hate It" || this.ruleForm.likeability == "I Don't Like It" || this.ruleForm.likeability == "Just So So"){
                        // 你喜欢我们产品吗？选项1-3跳转
                        freeGiftOrderThree(this.ruleForm).then((res=>{
                            if (res.data.code === 200) {
                                this.$message.success(res.data.message);
                                this.$refs[formName].resetFields();
                                // 跳转到下一步
                                this.$router.push(
                                    {
                                        path:'/share-experience-4',
                                        query:{
                                            address: res.data.data.address,
                                            amazonOrderId: res.data.data.amazonOrderId,
                                            email: res.data.data.email,
                                            name:res.data.data.name,
                                            // img_url:this.img_url
                                            remark:res.data.data.remark,
                                            url:res.data.data.url,
                                            image:this.image,
                                            title:this.title
                                        }
                                    }
                                )
                            }else if(res.data.code === 201){
                                this.$router.push('/noOrderId')
                            } else {
                                this.$message(res.data.message);
                            }
                        }))
                    }else{
                        // 你喜欢我们产品吗？选项4-5跳转
                        // this.$router.push('/share-experience-3');
                        freeGiftOrderThree(this.ruleForm).then((res=>{
                            if (res.data.code === 200) {
                                this.$message.success(res.data.message);
                                this.$refs[formName].resetFields();
                                // 跳转到下一步
                                this.$router.push(
                                    {
                                        path:'/share-experience-3',
                                        query:{
                                            address: res.data.data.address,
                                            amazonOrderId: res.data.data.amazonOrderId,
                                            email: res.data.data.email,
                                            name:res.data.data.name,
                                            remark:res.data.data.remark,
                                            image:this.image,
                                            url:res.data.data.url
                                        }
                                    }
                                )
                            } else {
                                this.$message(res.data.message);
                            }
                        }))
                    }
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.ruleForm.likeability = '';
            this.ruleForm.shareLevel = '';
            this.ruleForm.comment = '';
        }
    },
     created(){
        this.ruleForm.amazonOrderId = this.$route.query.amazonOrderId;
        this.image = this.$route.query.image;
        this.title = this.$route.query.title;
        if(sessionStorage.share2likeability){
            this.ruleForm.likeability = sessionStorage.share2likeability;
        }
         if(sessionStorage.share2share_level){
            this.ruleForm.shareLevel = sessionStorage.share2share_level;
        }
        if(sessionStorage.share2comment){
            this.ruleForm.comment = sessionStorage.share2comment;
        }
    },
    beforeRouteLeave(to,from,next){
      if(
          to.path == '/gift' || 
          to.path == '/warranty-activated' ||
          to.path == '/share-experience' ||
          to.path == 'share-experience-2' ||
          to.path == 'share-experience-3' ||
          to.path == 'share-experience-4'
          ){
            //缓存
          from.meta.keepAlive = true;
      }else{
            //不缓存
          from.meta.keepAlive = false ;
      }
      next()
  }
}
</script>
<style lang="less" scoped>
    .shareExperience{
        padding: 0px 30px;
        width: 70%;
        margin: 0 auto;
        padding-bottom: 50px;
        box-sizing: border-box;
       .step_title{
           margin-top: 20px;
           margin-bottom: 20px;
           p{
               font-size: 18px;
               color: #393838;
               line-height: 26px;
               margin-bottom: 10px;
               span{
                   color: #a099cb;
                   margin-right: 5px;
               }
           }
       }
       .post-content{
           display: flex;
           justify-content: space-around;
           margin-bottom: 30px;
           .post-content-left{
               width: 380px;
               margin-right: 4%;
               .fusion-title{
                   color: rgb(239, 129, 163);
                   font-size: 18px;
                   line-height: 26px;
                   font-weight: bold;
                   margin-bottom: 30px;
               }
           }
           .el-card{
              flex: 1;
           }
       }
    }
</style>